import apiClient from '../lib/apiClient';

const googleAdsService = {
  getStatus() {
    return apiClient.request('/google-ads/status');
  },

  getConnectUrl() {
    return apiClient.request('/google-ads/connect');
  },

  createCampaign(payload) {
    return apiClient.request('/google-ads/campaign', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  },

  listCampaigns() {
    return apiClient.request('/google-ads/campaigns');
  },

  syncCampaigns() {
    return apiClient.request('/google-ads/sync', {
      method: 'POST'
    });
  }
};

export default googleAdsService;
